import { render, staticRenderFns } from "./printDocument80mm.vue?vue&type=template&id=807a9cfe&"
import script from "./printDocument80mm.vue?vue&type=script&lang=js&"
export * from "./printDocument80mm.vue?vue&type=script&lang=js&"
import style0 from "./printDocument80mm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports